'use client';
import { useStore } from '@/store/store';

const jackpotsStatesMap = {
    Real: '',
    Default: 'default',
    Urgent: 'urgent',
    'Just won': 'justwon',
    Hidden: 'hidden',
    Cycle: 'cycle'
};

export const DailyJackpotsDebug = () => {
    const debug = useStore((s) => s.debug);

    const handleChange = (e: React.ChangeEvent) => {
        debug.setDailyJackpotsState(jackpotsStatesMap[e.target.id as keyof typeof jackpotsStatesMap]);
    };

    return (
        <section>
            <h3>Daily Jackpot State</h3>
            {Object.keys(jackpotsStatesMap).map((state, index) => (
                <div key={index}>
                    <input
                        id={state}
                        name="jackpotState"
                        type="radio"
                        checked={debug.mockedState === jackpotsStatesMap[state as keyof typeof jackpotsStatesMap]}
                        onChange={handleChange}
                    />
                    <label htmlFor={state}>{state}</label>
                </div>
            ))}
            <hr />
        </section>
    );
};
